const vapestonewholesale = {
    id: 'vapestonewholesale',
    publicSiteName: 'Vape Stone Wholesale',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION || 'r4jb-HmEtI1ZdFzd8fmFQz6i2UA5TO3d0ty6-lbWsdQ',
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#e00014',
            secondary: '#000000',
            color1: '#ac0211',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/vapestonewholesale/favicon.ico',
        logo: '/vapestonewholesale/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
    pricing: {
        showVatBreakdown: true,
        vatDisplayFormat: 'both',
    },
}

export default vapestonewholesale